// Tokens visuais do fluxo integrado (regras do design "Ciclo de Atendimento").
// Paleta de status reduzida a 4 tokens, sempre fundo claro + texto escuro: legível
// em densidade alta e não compete com o verde, que passa a significar só "ação
// primária" (deixa de ser cor de status).

export const TOKEN_NEUTRO = { color: '#4a5a6b', background: '#eef2f7' };
export const TOKEN_AZUL = { color: '#1c4a94', background: '#e7effc' };
export const TOKEN_AMBAR = { color: '#8a6a1f', background: '#fdf3dd' };
export const TOKEN_VERMELHO = { color: '#9b3b45', background: '#fbeaec' };

export const tokenStatus = (situacao) => {
    if (situacao === 'cancelado' || situacao === 'recusado') return TOKEN_VERMELHO;
    if (situacao === 'liberado' || situacao === 'em_analise') return TOKEN_AZUL;
    return TOKEN_NEUTRO;
};

// Data sentinela (1900-01-01) é o "não informado" gravado pelo próprio sistema.
export const semData = (data) => !data || data === '1900-01-01T00:00:00';

// Metadado de linha (vínculos, ids, contagens): texto cinza, nunca badge.
export const ESTILO_METADADO = { fontSize: '12px', color: '#8494a6' };

// Rótulo dos filtros.
export const ESTILO_ROTULO_FILTRO = {
    display: 'block', fontSize: '11px', fontWeight: 700, letterSpacing: '.06em',
    textTransform: 'uppercase', color: '#8494a6', marginBottom: '3px',
};

// Campos do filtro no mesmo visual. O app estiliza .form-select com borda 1px
// !important (index.css) para igualar ao react-select usado no resto do sistema —
// inline style não vence isso, então são os inputs que se alinham ao select, e não
// o contrário. Altura fixa porque .form-control (44px) e .form-select (38px) têm
// alturas diferentes por padrão.
const BASE_CAMPO_FILTRO = {
    height: '44px',
    borderRadius: '4px',
    fontSize: '13px',
    color: '#26364a',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: '12px',
};

export const ESTILO_INPUT_FILTRO = {
    ...BASE_CAMPO_FILTRO,
    border: '1px solid hsl(0, 0%, 80%)',   // mesma borda do .form-select
    paddingRight: '12px',
};

// a borda do select vem do CSS do app (!important); aqui só a métrica
export const ESTILO_SELECT_FILTRO = { ...BASE_CAMPO_FILTRO, paddingRight: '36px' };
